import { getConfig } from 'config';
import Subsidiaries from 'containers/Dashboard/components/SelectRequest';

export const getEquipmentsFields = () => {
  const equipmentsFields = [];
  const configFields = getConfig('tableColumns.standaloneFields');

  const defaultFields = {
    enabled: {
      type: 'select',
      name: 'enabled',
      options: [
        {
          label: 'Activado',
          value: 1,
        },
        {
          label: 'Desactivado',
          value: 0,
        },
      ],
      value: 'id',
      label: 'name',
    },
    subsidiaryId: {
      name: 'subsidiaryId',
      component: Subsidiaries
    }
  };
  
  configFields.map(item => {
    return equipmentsFields.push(defaultFields[item]);
  })
  
  return equipmentsFields;
}
